document.addEventListener("DOMContentLoaded", function() {
  const searchInput = document.querySelector('.faq__search input');
  const faqFilters = document.querySelector(".faq-filters");
  const faqTitle = document.querySelector(".main-page__content h2");
  const emptyMessage = document.querySelector(".faq__empty");
  const faqQuestionsContainer = document.querySelector(".faq__questions");

  const additionalContainers = document.querySelectorAll(".faq-questions-container");
  if (additionalContainers.length > 0) {
    additionalContainers.forEach(container => {
      const additionalQuestions = container.querySelectorAll(".accordion");
      additionalQuestions.forEach(question => {
        faqQuestionsContainer.appendChild(question);
      });
      container.remove();
    });
  }

  const allQuestions = document.querySelectorAll(".accordion");

  function setActiveFilter(filterValue) {
    const currentActive = faqFilters.querySelector('li.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }
    const newActive = faqFilters.querySelector(`li[data-filter="${filterValue}"]`);
    if (newActive) {
      newActive.classList.add('active');
    }
  }

  function applyFilter(filter) {
    let visibleCount = 0;
    for (let i = 0; i < allQuestions.length; i++) {
      const element = allQuestions[i];
      const category = element.dataset.category;

      if (filter === "all" || category.includes(filter)) {
        element.removeAttribute("hidden");
        visibleCount++;
      } else {
        element.setAttribute("hidden", "");
      }
    }
    if (visibleCount === 0) {
      emptyMessage.style.display = "block";
    } else {
      emptyMessage.style.display = "none";
    }
  }

  if (faqFilters) {
    faqFilters.addEventListener("click", function(event) {
      const target = event.target;
      if (target.matches('li')) {
        const filterValue = target.dataset.filter;
        const filterText = target.textContent;

        setActiveFilter(filterValue);
        faqTitle.textContent = filterText;
        applyFilter(filterValue);
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keyup', function() {
      const filter = this.value.toUpperCase();
      let visibleCount = 0;
      for (let i = 0; i < allQuestions.length; i++) {
        const details = allQuestions[i];
        const summary = details.querySelector('summary');
        const panel = details.querySelector('.item__contents');
        const textValue = (summary.textContent || summary.innerText) + " " + (panel.textContent || panel.innerText);

        if (textValue.toUpperCase().indexOf(filter) > -1) {
          details.removeAttribute("hidden");
          visibleCount++;
        } else {
          details.setAttribute("hidden", "");
        }
      }
      setActiveFilter("all");
      const allFilter = faqFilters.querySelector('li[data-filter="all"]');
      if (allFilter) {
        faqTitle.textContent = allFilter.textContent;
      }

      if (visibleCount === 0) {
        emptyMessage.style.display = "block";
      } else {
        emptyMessage.style.display = "none";
      }
    });
  }

  document.querySelectorAll('details').forEach((details) => {
    details.addEventListener('toggle', (event) => {
      if (details.open) {
        document.querySelectorAll('details').forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            otherDetails.open = false;
          }
        });
      }
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const categoryParam = urlParams.get('category');
  if (categoryParam) {
    const filterElement = faqFilters.querySelector(`li[data-filter="${categoryParam}"]`);
    if (filterElement) {
      filterElement.click();
    }
  } else {
    applyFilter("all");
  }
});